import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

// helper
import { BaseError } from '../../helpers/BaseError';

// models
import { TagModel } from './../../models/tag.model';

// API
import API from '../../services/api';

import formulaKeys from './_queryKeys';

export default function useFormulaTagsMutation(formulaId?: number) {
    const queryClient = useQueryClient();
    return useMutation<
        AxiosResponse<{ tags: TagModel[] }>,
        BaseError,
        { tags: string[] }
    >({
        mutationFn: (data: { tags: string[] }) =>
            API.updateFormulaTags({ formulaId, data }),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
        },
    });
}
